import HeroVideo from './HeroVideo';

const els = document.querySelectorAll('.js-hero-video');

for (let el of els) {
    new HeroVideo(el);
}
